var _path, _rect, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M39,45H9c0,0-3-0.1-3-8h36C42,44.9,39,45,39,45z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    fill: "#fff",
    width: 32,
    height: 34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212636"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 16,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 16,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#212636"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 31,
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.a747bea220749d38c3859c6660871c60.svg";
export { ForwardRef as ReactComponent };